import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

export type GetTopDecliningAssets = MarketplaceAssetType;
export type GetTopDecliningAssetsResponse = {
  getTopDecliningAssets: DefaultApiResponse<GetTopDecliningAssets[]>;
};
type GetTopDecliningAssetsArgs = MarketplaceAdditionalArgs;

export const getTopDecliningAssetsQuery: TypedDocumentNode<
  GetTopDecliningAssetsResponse,
  DefaultArg & GetTopDecliningAssetsArgs
> = gql`
  query GetTopDecliningAssets(
    $record: AssetGrowthRecord!
    $rateRecord: AssetsRateChangeRecord!
    $changeRecord: AssetsRateChangeRecord!
  ) {
    getTopDecliningAssets(record: $record) {
      code
      iconUrl
      isFavorite
      name
      rate(record: $rateRecord)
      change(record: $changeRecord)
    }
  }
`;
